import IconTel from "assets/images/icon_tel.png"
import IconTop from "assets/images/icon_top.png"
import IconCenter from "assets/images/icon_center.png"
import IconTelegram from "assets/images/icon_telegram.png"

import { Link } from 'react-router-dom';

export default function Footer() {
  // 스크롤 최상단
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  // 새창 띄우기
  const OpenWindow = (url) => {
    window.open(url, '_blank');
  }
  return (
    <footer>
      <div className="footer_icon">
        <Link to="/myPage/inquery"><img src={IconCenter} alt="icon_center" /></Link>
        <Link onClick={() => OpenWindow('https://t.me/+NF6nudB-WSMzM2Qx')}><img src={IconTel} alt="icon_tel" /></Link>
        <div className="scrollTop_btn" onClick={scrollToTop}>
          <img src={IconTop} alt="icon_top" />
        </div>
      </div>
      <div className="inner_footer">
        <p className="mb_5">
          © 2024 Copyright  tmt  All rights reserved. | 모든 저작권을 소유하고 있습니다. <br />
          TMT.com 은 플레이어에게 최고의 온라인 카지노 경험을 제공하는 커뮤니티 기반 암호화폐 카지노입니다!  <br />
          TMT.com에서 우리는 블록체인이 온라인 암호화 도박 산업을 영원히 바꿀 것이라고 확신합니다!  <br />
          직접 눈으로 확인해보세요! 그리고 암호화폐를 획득하세요!
        </p>
        <p>
          <Link onClick={() => OpenWindow('https://t.me/+NF6nudB-WSMzM2Qx')}>
            <img src={IconTelegram} alt="telegram" /> @tmt_info
          </Link>
        </p>
      </div>
    </footer>
  )
}